import React from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import logo from "../../assets/images/logos/logo.png";
import logoAnimated from "../../assets/images/logos/logo.gif";
import { USER_DATA } from "../../helpers/constants";
// import Searcher from "./Searcher";
import isolation_Mode from "../../assets/fonts/Isolation_Mode.svg";
import user_icon from "../../assets/fonts/user_icon.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, fatimes } from "@fortawesome/free-solid-svg-icons";

function NewHeader({ location, history }) {
    const onNavToggled = () => {
        const navbarElement = document.getElementById("navbar");
        const togglerElement = document.getElementById("toggler");
        if (navbarElement) {
          navbarElement.classList.toggle("navbar-mobile");
        }
        if (togglerElement) {
          togglerElement.classList.toggle("bx-menu");
          togglerElement.classList.toggle("bx-x");
        }
      };
    
      const onLogout = () => {
        try {
          localStorage.removeItem(USER_DATA);
          history.push("/");
        } catch (error) {
          console.log(error);
        }
      };
    
      const { pathname } = location;
    
      return (
        <header
          id="header"
          className="container-fluid w-full px-0 fixed flex items-center bg-white"
        >
          <div className="container">
            <div className="w-full flex justify-between items-center">
              <Link className="navbar-brand" to="/">
                <img id="logo-simple" src={logo} alt="app logo" />
                <img
                  id="logo-animated"
                  src={logoAnimated}
                  alt="app logo animated"
                />
              </Link>
              <nav id="navbar" className="navbar flex items-center justify-end">
                {localStorage.getItem(USER_DATA) &&
                ["/help", "/messages", "/notifications", "/account"].includes(
                  pathname
                ) ? (
                  <ul>
                    <li>
                      <Link
                        to="/"
                        className={`nav-link${
                          pathname.includes("/help") ? " active" : ""
                        } nav-account`}
                      >
                        <i className="bx bx-help-circle bx-sm lh-1"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/"
                        className={`nav-link${
                          pathname.includes("/messages") ? " active" : ""
                        } nav-account`}
                      >
                        <i className="bx bxs-message-dots bx-sm lh-1"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/"
                        className={`nav-link${
                          pathname.includes("/notifications") ? " active" : ""
                        
                        } nav-account`}
                      >
                        <i className="bx bxs-bell bx-sm lh-1"></i>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        className="nav-link nav-account mr-0"
                        onClick={() => onLogout()}
                      >
                        <i className="bx bx-log-out-circle bx-sm lh-1"></i>
                      </Link>
                    </li>
                  </ul>
                ) : (
                  <ul className="flex lg:space-x-12">
                    <li>
                      <Link
                        to="/opportunites"
                        className={`nav-link${
                          pathname.includes("/opportunites") ? " active" : ""
                        }`}
                      >
                        Opportunités
                      </Link>
                    </li>
                    <li>
                      <Link
                        to=""
                        className={`nav-link${pathname === "" ? " active" : ""}`}
                      >
                        Orientation
                      </Link>
                    </li>
                    <li>
                      <Link
                        to=""
                        className={`nav-link${pathname === "" ? " active" : ""}`}
                      >
                        Métiers
                      </Link>
                    </li>
                    <span className="flex justify-end items-center space-x-3">
                      {pathname ? (
                        <div className="hidden w-12 lg:flex justify-center items-center h-auto bg-ace-green p-1.5 rounded-full cursor-pointer">
                          <img
                            src={isolation_Mode}
                            alt="search icon"
                            className="w-5 h-5"
                          />
                        </div>
                      ) : null}
                      <li className="">
                        {localStorage.getItem(USER_DATA) ? (
                          <Link
                            to="/account"
                            className={`${
                              ["/account"].includes(pathname) ? " active" : ""
                            } nav-account`}
                          >
                            <i className="bx bxs-user-circle bx-md lh-1"></i>
                          </Link>
                        ) : (
                          <Link
                            to="/login"
                            className={`hidden lg:bg-ace-ace_title rounded-full text-white${
                              ["/login", "/register"].includes(pathname)
                                ? " active"
                                : ""
                            }`}
                          >
                            <span className="px-3 py-1.5 hidden lg:flex justify-center items-center space-x-1">
                              <img
                                src={user_icon}
                                alt="user icon"
                                className="w-5 h-5"
                              />
                              <p className="font-[700]">Login</p>
                            </span>
                          </Link>
                        )}
                      </li>
                    </span>
                  </ul>
                )}
    
                <i
                  id="toggler"
                  className="bx bx-menu mobile-nav-toggle"
                  onClick={onNavToggled}
                />
              </nav>
            </div>
          </div>
        </header>
      );
    };
    
    const mapStateToProps = (state) => ({});
    
    const mapDispatchToProps = (dispatch) => ({});

    export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NewHeader));